import { Action, combineReducers, configureStore, PayloadAction, ThunkAction } from "@reduxjs/toolkit"
import { attachAuthToken } from "../api"
import authReducer from "./auth.store"
import consolidationReducer from "./consolidation.store"
import customerReducer from "./customer.store"
import dispatchReducer from "./dispatch.store"
import dropReducer from "./drop.store"
import economyconsolsReducer from "./economyconsol.store"
import fulfillmentReducer from "./fulfillment.store"
import groupReducer from "./group.store"
import linehaulReducer from "./linehaul.store"
import ordersReducer from "./order.store"
import parcelReducer from "./parcel.store"
import pickReducer from "./pick.store"
import pricingReducer from "./pricing.store"
import promoCodeReducer from "./promoCode.store"
import purchaseRequestReducer from "./purchaseRequest.store"
import suiteReducer from "./suite.store"
import userReducer from "./user.store"
import warehouseReducer from "./warehouse.store"

const rootReducer = combineReducers({
    auth: authReducer,
    users: userReducer,
    parcels: parcelReducer,
    promoCodes: promoCodeReducer,
    suites: suiteReducer,
    consolidations: consolidationReducer,
    drops: dropReducer,
    picks: pickReducer,
    dispatchs: dispatchReducer,
    warehouses: warehouseReducer,
    groups: groupReducer,
    customers: customerReducer,
    purchaseRequest: purchaseRequestReducer,
    pricing: pricingReducer,
    economyconsols: economyconsolsReducer,
    orders: ordersReducer,
    linehaul: linehaulReducer,
    fulfillments: fulfillmentReducer
})

const persistanceMiddleware = (store: any) => {
    return (next: any) => {
        return (action: PayloadAction<any>) => {
            const result = next(action)
            return result
        }
    }
}

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        }).concat([persistanceMiddleware]),
    devTools: process?.env?.REACT_APP_NODE_ENV !== "production"
})

const initialState: RootState = store.getState()

/**
 * Start loading data into the redux store
 */

if (initialState.auth.userInfo?.accesstToken || localStorage.getItem("accessToken")) {
    attachAuthToken(initialState.auth?.userInfo?.accesstToken || localStorage.getItem("accessToken"))
}

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>

export default store
